import { SxProps, Theme } from "@mui/material";
import { EMAIL_CONTENT_BASELINE } from "@simplyk/common";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface EmailContentPreviewProps {
  html: string;
  sx?: SxProps<Theme>;
  "data-test"?: string;
}

export const EmailContentPreview = ({ html, sx, ...rest }: EmailContentPreviewProps) => {
  return (
    <DashboardTypography
      variant="body2"
      dangerouslySetInnerHTML={{ __html: html }}
      sx={[
        {
          wordBreak: "break-word",
          overflowWrap: "break-word",
          "& p": {
            margin: EMAIL_CONTENT_BASELINE.paragraphMargin,
          },
          "& a": {
            wordBreak: "break-all",
            overflowWrap: "anywhere",
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...rest}
    />
  );
};
